import React from "react";
import { Link } from "react-router-dom";
import { FaCalendarAlt, FaClock, FaUser } from "react-icons/fa";

export default function BlogCard({ blog }) {
  const formattedDate = blog.publishedAt
    ? new Date(blog.publishedAt).toLocaleDateString("en-US", {
        year: "numeric",
        month: "short",
        day: "numeric",
      })
    : "";

  return (
    <div className="blog-card">
      <Link to={`/blog/${blog.slug}`} className="blog-card-image-link">
        {blog.coverImage ? (
          <img
            src={blog.coverImage}
            alt={blog.title}
            className="blog-card-image"
            loading="lazy"
          />
        ) : (
          <div className="blog-card-image-placeholder">
            <span>No Image</span>
          </div>
        )}
      </Link>
      <div className="blog-card-body">
        {blog.type && <span className="blog-card-type">{blog.type}</span>}
        <h3 className="blog-card-title">
          <Link to={`/blog/${blog.slug}`}>{blog.title}</Link>
        </h3>
        {blog.excerpt && (
          <p className="blog-card-excerpt">{blog.excerpt}</p>
        )}
        <div className="blog-card-meta">
          <span className="blog-card-meta-item">
            <FaCalendarAlt /> {formattedDate}
          </span>
          <span className="blog-card-meta-item">
            <FaClock /> {blog.readingTime}
          </span>
          {blog.author?.name && (
            <span className="blog-card-meta-item">
              <FaUser /> {blog.author.name}
            </span>
          )}
        </div>
      </div>
    </div>
  );
}
